import { NgModule } from '@angular/core';
import { CreateProjectRoutingModule } from './create-project-routing.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CreateProjectRoutingModule
  ]
})
export class CreateProjectModule { }
